<button
  matRipple
  [style.color]="properties.color"
  [style.background]="properties.background"
>
  <i aria-hidden="true" class="material-icons">{{ properties.icon }}</i>
  <span class="slider-text" [style.--text-length]="textLength">{{ properties.text }}</span>
</button>
